import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { InfinityIcon } from "../../icons";
import { Text } from "../../Text";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var TEXT_SIZE = {
  s: 'size5-r-s',
  m: 'size4-r'
};
var isFirefox = typeof window !== 'undefined' && window.navigator.userAgent.includes('Firefox');
export var RangeSlider = /*#__PURE__*/memo(function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'main' : _ref$variant,
    unit = _ref.unit,
    steps = _ref.steps,
    title = _ref.title,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    infinity = _ref.infinity,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    lastIndex = _ref.lastIndex,
    _ref$firstIndex = _ref.firstIndex,
    firstIndex = _ref$firstIndex === void 0 ? 0 : _ref$firstIndex,
    _ref$defaultIndex = _ref.defaultIndex,
    defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
    extraAttributes = _ref.extraAttributes,
    textBeforeValue = _ref.textBeforeValue,
    rightText = _ref.rightText,
    rightSteps = _ref.rightSteps,
    rightUnit = _ref.rightUnit,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'RangeSlider' : _ref$testName;
  var _useState = useState(_toConsumableArray(steps)),
    _useState2 = _slicedToArray(_useState, 2),
    newSteps = _useState2[0],
    setNewSteps = _useState2[1];
  var _useState3 = useState(rightSteps && _toConsumableArray(rightSteps)),
    _useState4 = _slicedToArray(_useState3, 2),
    currentRightSteps = _useState4[0],
    setCurrentRightSteps = _useState4[1];
  var _useState5 = useState(lastIndex),
    _useState6 = _slicedToArray(_useState5, 2),
    newLastIndex = _useState6[0],
    setNewLastIndex = _useState6[1];
  var progressbarRef = useRef(null);
  var _useState7 = useState(defaultIndex),
    _useState8 = _slicedToArray(_useState7, 2),
    sliderValue = _useState8[0],
    setSliderValue = _useState8[1];
  var onSliderChange = useCallback(function (v) {
    var value = +v;
    if (value > newLastIndex) {
      value = newLastIndex;
    }
    if (progressbarRef !== null && progressbarRef !== void 0 && progressbarRef.current) {
      // Logic for setting progressbar position and this is one of the possible solution
      var newValue = Number((value - firstIndex) / (newLastIndex - firstIndex)) * 100; // percent
      // когда приходит только один степ и надо показать всю шкалу заполненной
      if (steps.length === 1) {
        newValue = 100;
      }
      progressbarRef.current.style.width = "".concat(newValue, "%");
    }
    // когда приходит только один степ и надо показать всю шкалу заполненной
    if (steps.length === 1 && newSteps.length === 1) {
      setNewLastIndex(1);
      setSliderValue(1);
      onChange(newSteps[0]);
    }
    // Logic for changing values and handle onChange
    if (steps.length !== 1) {
      setSliderValue(value);
      onChange(newSteps[value]);
    }
  }, [newLastIndex, steps.length, newSteps, firstIndex, onChange]);

  /* реализация с обновлением степс и райт степс для кейсов,
   если меняется значение этих пропов динамически (например переключением табов
    меняется доступный набор значений) */
  useEffect(function () {
    if (steps.length === 1) {
      setNewSteps([0].concat(_toConsumableArray(steps)));
    } else setNewSteps(_toConsumableArray(steps));
  }, [steps]);
  useEffect(function () {
    if (rightSteps) {
      if (rightSteps.length === 1) {
        setCurrentRightSteps([0].concat(_toConsumableArray(rightSteps)));
      } else setCurrentRightSteps(_toConsumableArray(rightSteps));
    }
  }, [rightSteps]);
  useEffect(function () {
    onSliderChange(defaultIndex);
    // eslint-disable-next-line
  }, [defaultIndex]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('label'),
    "data-component": testName,
    "data-t-id": "inputs-RangeSlider"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx('label__title')
  }, /*#__PURE__*/React.createElement(Text, {
    size: TEXT_SIZE[size],
    tagType: "span"
  }, title)), infinity && sliderValue === newLastIndex ? /*#__PURE__*/React.createElement(InfinityIcon, {
    size: "s"
  }) : /*#__PURE__*/React.createElement(Text, {
    color: "textIconElementTertiary",
    size: "size5-r-s",
    tagType: "span"
  }, textBeforeValue, " ", newSteps[sliderValue], " ", unit)), /*#__PURE__*/React.createElement("div", {
    className: cx('label--right-text')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('label__title')
  }, /*#__PURE__*/React.createElement(Text, {
    size: TEXT_SIZE.s,
    tagType: "span"
  }, rightText)), currentRightSteps && currentRightSteps.length > 0 && currentRightSteps[sliderValue] > 0 && /*#__PURE__*/React.createElement(Text, {
    color: "textIconElementTertiary",
    size: "size5-r-s",
    tagType: "span"
  }, currentRightSteps[sliderValue], "\xA0", rightUnit))), /*#__PURE__*/React.createElement("div", {
    className: cx('range-slider')
  }, /*#__PURE__*/React.createElement("input", _extends({}, extraAttributes, {
    className: cx('range-slider__input', {
      'range-slider__input--disabled': disabled,
      'range-slider__input--secondary': variant === 'secondary'
    }),
    disabled: disabled,
    max: newLastIndex,
    min: firstIndex,
    onChange: function onChange(e) {
      return onSliderChange(e.target.value);
    },
    step: 1,
    type: "range",
    value: sliderValue
  })), !isFirefox && /*#__PURE__*/React.createElement("div", {
    className: cx('range-slider__progressbar', {
      'range-slider__progressbar--disabled': disabled
    }, {
      'range-slider__progressbar--secondary': variant === 'secondary'
    }),
    ref: progressbarRef
  })));
});